import { useI18n } from 'i18n/hooks/useI18n';
import { searchGetVolopsRoutePath } from 'modules/search/routing/helpers/searchGetVolopsRoutePath';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { PageHeaderButtonOrLink } from './PageHeader.styled';

type Props = {
  locale: UserLocale;
};

export function VolunteerLink({ locale }: Props) {
  const { i18n } = useI18n();
  return (
    <PageHeaderButtonOrLink
      qaId="nav-volop-link"
      href={searchGetVolopsRoutePath({ lang: locale })}
      onClick={() =>
        trackClicked('Volunteer', { context: 'Header Dropdown > Take Action' })
      }
      type="link"
    >
      {i18n('Volunteer')}
    </PageHeaderButtonOrLink>
  );
}
